var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"send-sms-code",attrs:{"type":"text","disabled":Boolean(_vm.countDown),"size":"small"},on:{"click":_vm.handleSendSMSCode}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }